"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable-next-line: no-submodule-imports
var buffer_1 = require("buffer/");
var BinaryEncoder = __importStar(require("./binary-encode"));
var Encoder = __importStar(require("./encoder"));
var JsonEncoder = __importStar(require("./json-encode"));
var options_1 = require("./options");
var util_1 = require("./util");
var Codec = /** @class */ (function () {
    function Codec() {
        this.symbolConcreteInfo = Symbol("concreateInfo");
    }
    Object.defineProperty(Codec.prototype, "symbols", {
        get: function () {
            return {
                concreteInfo: this.symbolConcreteInfo
            };
        },
        enumerable: true,
        configurable: true
    });
    Codec.prototype.marshalBinaryBare = function (value) {
        if (!value) {
            throw new Error("value is null");
        }
        if (typeof value !== "object") {
            throw new Error("only support object");
        }
        var typeInfo = util_1.getTypeInfo(this, value);
        if (!typeInfo) {
            throw new Error("type info should be set");
        }
        var bz = BinaryEncoder.encodeReflectBinary(this, typeInfo, value, options_1.defaultFieldOptions({ binFieldNum: 1 }), true);
        if (typeInfo.concreteInfo && typeInfo.concreteInfo.registered) {
            bz = buffer_1.Buffer.concat([
                buffer_1.Buffer.from(typeInfo.concreteInfo.prefix),
                buffer_1.Buffer.from(bz)
            ]);
        }
        return bz;
    };
    Codec.prototype.marshalBinaryLengthPrefixed = function (value) {
        var bz = this.marshalBinaryBare(value);
        bz = buffer_1.Buffer.concat([
            buffer_1.Buffer.from(Encoder.encodeUvarint(bz.length)),
            buffer_1.Buffer.from(bz)
        ]);
        return bz;
    };
    Codec.prototype.marshalJson = function (value, space) {
        if (!value) {
            throw new Error("value is null");
        }
        if (typeof value !== "object") {
            throw new Error("only support object");
        }
        var typeInfo = util_1.getTypeInfo(this, value);
        if (!typeInfo) {
            throw new Error("type info should be set");
        }
        var result = "";
        if (typeInfo.concreteInfo && typeInfo.concreteInfo.registered) {
            result = "{\"type\":\"" + typeInfo.concreteInfo.name + "\",\"value\":";
        }
        result += JsonEncoder.encodeReflectJSON(this, typeInfo, value, options_1.defaultFieldOptions({ binFieldNum: 1 }));
        if (typeInfo.concreteInfo && typeInfo.concreteInfo.registered) {
            result += "}";
        }
        if (space) {
            result = JSON.stringify(JSON.parse(result), null, space);
        }
        return result;
    };
    Codec.prototype.registerConcrete = function (name, value) {
        if (typeof value !== "object") {
            throw new Error("can register only object");
        }
        var disfix = util_1.nameToDisfix(name);
        var typeInfo = util_1.getTypeInfo(this, value);
        if (typeInfo) {
            var concreteInfo = typeInfo.concreteInfo;
            if (!concreteInfo) {
                concreteInfo = {
                    registered: true,
                    name: name,
                    disamb: disfix.disambBytes,
                    prefix: disfix.prefixBytes
                };
            }
            else {
                // shallow copy
                concreteInfo = __assign({}, concreteInfo);
                if (concreteInfo.registered) {
                    throw new Error("concrete already registered");
                }
                concreteInfo.registered = true;
                concreteInfo.name = name;
                concreteInfo.disamb = disfix.disambBytes;
                concreteInfo.prefix = disfix.prefixBytes;
            }
            util_1.setConcreteInfoForCodec(this, value, concreteInfo);
        }
        else {
            throw new Error("unregistered type");
        }
    };
    return Codec;
}());
exports.Codec = Codec;
//# sourceMappingURL=codec.js.map